import React from 'react'
import PropTypes from 'prop-types'
import { Billboard } from '@instructure/ui-billboard'
import { IconWarningLine } from '@instructure/ui-icons'

const Error = ({ heading, message, children }) => {
  return message ? (
    <Billboard
      margin="x-large"
      heading={heading}
      message={message}
      size="large"
      hero={(size) => <IconWarningLine size={size}/>}
    />
  ) : children
}

Error.propTypes = {
  heading: PropTypes.string,
  message: PropTypes.string,
  children: PropTypes.node.isRequired
}

Error.defaultProps = {
  heading: "Error",
  message: null
}

export default Error